import { useState } from "react";

const TABS = ["全部", "联动", "跨界", "串门", "后续"];

const FEEDS = [
  { tab: 0, tag: "联动", title: "网传两档综艺拟联合录特辑，冠名商已下场", src: "整理自公开招商信息" },
  { tab: 0, tag: "串门", title: "某音乐人将客串新剧，角色名与曲名同款", src: "多方行程互证" },
  { tab: 1, tag: "联动", title: "剧集主演与综艺MC同框录制，官微卡点发文", src: "官微 + 路透" },
  { tab: 1, tag: "后续", title: "联动特辑收视出炉，片方回应“有第二弹”", src: "片方回应" },
  { tab: 2, tag: "跨界", title: "电影导演跨界执导舞台剧，排练照释出", src: "剧院官宣" },
  { tab: 2, tag: "串门", title: "老戏骨串门声优综艺，预告只露两秒", src: "预告帧分析" },
  { tab: 3, tag: "串门", title: "选秀元老回访初舞台，主题曲前奏一响就泪目", src: "现场观众repo" },
  { tab: 4, tag: "后续", title: "联动风波后，双后援会联合发布文明吃瓜倡议", src: "后援会发文" },
];

export default function QuanSection() {
  const [active, setActive] = useState(0);

  const visible = FEEDS.filter((f) => active === 0 || f.tab === active);

  return (
    <section id="quan" className="scroll-mt-20 bg-background-100/60 py-10 md:py-14">
      <div className="container-x">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-400" /> SCOOP WATCH
            </p>
            <h2 className="mt-2 font-display text-2xl text-foreground-900 md:text-3xl">
              圈外爆料 · 一条线跟进
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            圈外出的瓜也别错过，所有爆料都附上来源口径，帮你判断是实锤还是画饼。
          </p>
        </div>

        {/* segmented control */}
        <div className="mt-6 flex flex-wrap gap-2">
          {TABS.map((t, i) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(i)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === i
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200/70 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {visible.map((f) => (
            <a
              key={f.title}
              href="#lian"
              className="group flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-200 md:p-5"
            >
              <span className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-leaf-line" />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="whitespace-nowrap rounded bg-background-200 px-2 py-0.5 text-xs text-foreground-700">
                    {f.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{f.src}</span>
                </div>
                <h3 className="mt-2 leading-snug text-foreground-900 group-hover:text-primary-600">
                  {f.title}
                </h3>
              </div>
              <i className="ri-external-link-line mt-1 text-foreground-300 transition-colors group-hover:text-primary-500" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}